import React from 'react'

class Line extends React.Component {
  render() {
    return (<line
      data-name = {this.props.name}
      data-imports = {this.props.imports}
      data-exports = {this.props.exports}
        x1={(this.props.exports / this.props.maxVal) * 100}
        y1="0"
        x2={(this.props.imports / this.props.maxVal) * 100}
        y2="100"
        style={{
          "stroke" : this.props.selected ? "#f00" : "#888",
          "strokeWidth" : this.props.selected ? 4 : 1,
        }}
        vectorEffect="non-scaling-stroke"
        onMouseOver={this.props.hover}
        onMouseOut={this.props.unhover}/>)
  }
}

class Axis extends React.Component {
  // render() {
  //   return (<div className="axis">
  //     <div>{`£${this.props.min}bn`}</div>
  //     <div>{this.props.label}</div>
  //     <div>{`£${this.props.max}bn`}</div>
  //   </div>)
  // }
    render() {
      return (<div className="axis">
        <div>{`${this.props.label}`}</div>
      </div>)
    }
}

class Barcode extends React.Component {
  constructor(props) {
    super(props);
    this.hover = this.hover.bind(this);
    this.unhover = this.unhover.bind(this);
    this.state = {hovered: this.props.selected};
  }

  hover(e) {
    this.setState({hovered: `${e.target.dataset.name} (exports £${e.target.dataset.exports}bn / imports: £${e.target.dataset.imports}bn)`});
  }

  unhover(e) {
    this.setState({hovered: " "});
  }

  render() {
    return (<div className="barcode">
    <div style={{color: "#000",  fontSize:"1.2rem"}}>{this.state.hovered}</div>
      <Axis min="0" max={this.props.data.maxVal} label="Exports of goods"/>
      <svg width="100%" height="100px" viewBox="0 0 100 100" preserveAspectRatio="none">
        {this.props.data.country.map((country, index) => (
          <Line
            key={index}
            name={country.name}
            exports={country.exports}
            imports={country.imports}
            maxVal={this.props.data.maxVal}
            selected={this.props.selected==country.name}
            hover={this.hover}
            unhover={null}
            />))}
      </svg>
      <Axis min="0" max={this.props.data.maxVal} label="Imports of goods"/>
    </div>)
  }
}

export default Barcode



// WEBPACK FOOTER //
// ./src/components/barcode.js